import React from "react";
import wireIf from "./wireIf";

function Disabled({ children, authorized }) {
  return React.cloneElement(children, { disabled: !authorized });
}

export default function disabledUnless(lambda) {
  return wireIf(lambda, "authorized", Disabled);
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/authorization/disabledUnless.js